"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _logger = require("@insided/shared/services/logger");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _EventListOverview = _interopRequireDefault(require("@insided/deprecated-preact-components/Event/EventListOverview"));

var _qs = _interopRequireDefault(require("qs"));

var _axios = _interopRequireDefault(require("axios"));

var _classnames = _interopRequireDefault(require("classnames"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var cssAnchorName = 'events-overview-new';
exports.cssAnchorName = cssAnchorName;
var INITIAL_PAGE = 1;

var prepareParametersForRequest = function prepareParametersForRequest() {
  var _queryParameters$page;

  var searchQuery = typeof window !== 'undefined' ? window.location.search : '';

  var queryParameters = _qs.default.parse(searchQuery, {
    ignoreQueryPrefix: true
  });

  return {
    page: (_queryParameters$page = queryParameters.page) !== null && _queryParameters$page !== void 0 ? _queryParameters$page : 1,
    tab: queryParameters.tab,
    type: queryParameters.type
  };
};

var setQueryParameters = function setQueryParameters(newQuery) {
  var searchQuery = window.location.search;

  var queryParameters = _qs.default.parse(searchQuery, {
    ignoreQueryPrefix: true
  });

  var combinedQuery = _objectSpread(_objectSpread({}, queryParameters), newQuery);

  if ((combinedQuery === null || combinedQuery === void 0 ? void 0 : combinedQuery.page) === 1) {
    combinedQuery === null || combinedQuery === void 0 ? true : delete combinedQuery.page;
  }

  window.history.pushState('', '', "?".concat(_qs.default.stringify(combinedQuery)));
};

var EventOverviewNew = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(EventOverviewNew, _Component);

  var _super = _createSuper(EventOverviewNew);

  function EventOverviewNew(props) {
    var _this;

    (0, _classCallCheck2.default)(this, EventOverviewNew);
    _this = _super.call(this, props); // eslint-disable-next-line react/state-in-constructor

    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onPushState", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _this$state, upcoming, past, isTabChanged;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$state = _this.state, upcoming = _this$state.upcoming, past = _this$state.past, isTabChanged = _this$state.isTabChanged;

              if (!isTabChanged) {
                _context.next = 5;
                break;
              }

              _this.setState({
                isTabChanged: false
              });

              _context.next = 12;
              break;

            case 5:
              if (!(upcoming.isPageNumberIncreased || past.isPageNumberIncreased)) {
                _context.next = 10;
                break;
              }

              _context.next = 8;
              return _this.getMoreEvents();

            case 8:
              _context.next = 12;
              break;

            case 10:
              _context.next = 12;
              return _this.fetchEvents();

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchEvents", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var searchQuery, queryParameters, res, _res$data$upcomingEve, _res$data$pastEvents;

      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              searchQuery = typeof window !== 'undefined' ? window.location.search : '';
              queryParameters = _qs.default.parse(searchQuery, {
                ignoreQueryPrefix: true
              });

              _this.setState({
                isLoading: true
              });

              _context2.next = 5;
              return _axios.default.get('/events/events', {
                params: {
                  type: queryParameters.type
                }
              });

            case 5:
              res = _context2.sent;

              if (res.data) {
                _this.setState({
                  upcoming: {
                    events: (_res$data$upcomingEve = res.data.upcomingEvents) !== null && _res$data$upcomingEve !== void 0 ? _res$data$upcomingEve : [],
                    currentPage: INITIAL_PAGE,
                    totalPageCount: res.data.totalPageCountUpcoming,
                    isPageNumberIncreased: false,
                    showBackButton: false
                  },
                  past: {
                    events: (_res$data$pastEvents = res.data.pastEvents) !== null && _res$data$pastEvents !== void 0 ? _res$data$pastEvents : [],
                    currentPage: INITIAL_PAGE,
                    totalPageCount: res.data.totalPageCountPast,
                    isPageNumberIncreased: false,
                    showBackButton: false
                  },
                  isLoading: false
                });
              }

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    _this.state = {
      upcoming: {
        events: props.upcomingEventsNew,
        currentPage: 1,
        totalPageCount: props.totalPageCountUpcoming,
        isPageNumberIncreased: false,
        showBackButton: false
      },
      past: {
        events: props.pastEventsNew,
        currentPage: 1,
        totalPageCount: props.totalPageCountPast,
        isPageNumberIncreased: false,
        showBackButton: false
      },
      eventsTab: '',
      isTabChanged: false,
      isLoading: false
    };
    _this.getMoreEvents = _this.getMoreEvents.bind((0, _assertThisInitialized2.default)(_this));
    _this.setPagination = _this.setPagination.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(EventOverviewNew, [{
    key: "setPagination",
    value: function setPagination(newPage) {
      var _this$state2 = this.state,
          eventsTab = _this$state2.eventsTab,
          upcoming = _this$state2.upcoming,
          past = _this$state2.past;
      var isUpcomingEventsTab = eventsTab === 'upcoming';

      if (isUpcomingEventsTab) {
        this.setState({
          upcoming: _objectSpread(_objectSpread({}, upcoming), {}, {
            currentPage: newPage,
            isPageNumberIncreased: newPage > upcoming.currentPage ? true : upcoming.isPageNumberIncreased
          })
        }, function () {
          return setQueryParameters({
            page: newPage
          });
        });
      } else {
        this.setState({
          past: _objectSpread(_objectSpread({}, past), {}, {
            currentPage: newPage,
            isPageNumberIncreased: newPage > past.currentPage ? true : past.isPageNumberIncreased
          })
        }, function () {
          return setQueryParameters({
            page: newPage
          });
        });
      }
    }
  }, {
    key: "getMoreEvents",
    value: function () {
      var _getMoreEvents = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var params, _this$state3, upcoming, past, eventsTab, isTabChanged, isUpcomingEventsTab, res, _res$data$upcomingEve2, _res$data$pastEvents2, resDataUpcoming, resDataPast;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                params = prepareParametersForRequest();
                _this$state3 = this.state, upcoming = _this$state3.upcoming, past = _this$state3.past, eventsTab = _this$state3.eventsTab, isTabChanged = _this$state3.isTabChanged;
                isUpcomingEventsTab = eventsTab === 'upcoming';

                if (!isTabChanged) {
                  _context3.next = 6;
                  break;
                }

                this.setState({
                  isTabChanged: false
                });
                return _context3.abrupt("return");

              case 6:
                this.setState({
                  isLoading: true
                });
                _context3.prev = 7;
                _context3.next = 10;
                return _axios.default.get('/events/events', {
                  params: params
                });

              case 10:
                res = _context3.sent;

                if (res.data) {
                  resDataUpcoming = (_res$data$upcomingEve2 = res.data.upcomingEvents) !== null && _res$data$upcomingEve2 !== void 0 ? _res$data$upcomingEve2 : null;
                  resDataPast = (_res$data$pastEvents2 = res.data.pastEvents) !== null && _res$data$pastEvents2 !== void 0 ? _res$data$pastEvents2 : null;

                  if (resDataUpcoming) {
                    this.setState({
                      upcoming: _objectSpread(_objectSpread({}, upcoming), {}, {
                        events: upcoming.isPageNumberIncreased ? upcoming.events.concat(resDataUpcoming) : resDataUpcoming,
                        currentPage: upcoming.isPageNumberIncreased ? upcoming.currentPage : 1,
                        totalPageCount: res.data.totalPageCountUpcoming,
                        isPageNumberIncreased: false,
                        // Hide show back button if filters are changing except pagination
                        showBackButton: upcoming.isPageNumberIncreased ? upcoming.showBackButton : false
                      }),
                      isLoading: false
                    });
                  }

                  if (resDataPast) {
                    this.setState({
                      past: _objectSpread(_objectSpread({}, past), {}, {
                        events: past.isPageNumberIncreased ? past.events.concat(resDataPast) : resDataPast,
                        currentPage: past.isPageNumberIncreased ? past.currentPage : 1,
                        totalPageCount: res.data.totalPageCountPast,
                        isPageNumberIncreased: false,
                        // Hide show back button if filters are changing except pagination
                        showBackButton: past.isPageNumberIncreased ? past.showBackButton : false
                      }),
                      isLoading: false
                    });
                  }
                }

                _context3.next = 19;
                break;

              case 14:
                _context3.prev = 14;
                _context3.t0 = _context3["catch"](7);

                _logger.logger.error(_context3.t0, {
                  component: 'EventOverviewNew',
                  action: 'getMoreEvents'
                });

                if (isUpcomingEventsTab) {
                  this.setState({
                    upcoming: _objectSpread(_objectSpread({}, upcoming), {}, {
                      isPageNumberIncreased: false
                    })
                  });
                } else {
                  this.setState({
                    past: _objectSpread(_objectSpread({}, past), {}, {
                      isPageNumberIncreased: false
                    })
                  });
                }

                this.setState({
                  isLoading: false
                });

              case 19:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[7, 14]]);
      }));

      function getMoreEvents() {
        return _getMoreEvents.apply(this, arguments);
      }

      return getMoreEvents;
    }() // eslint-disable-next-line class-methods-use-this

  }, {
    key: "handleBackNavigation",
    value: function handleBackNavigation() {
      window.location.reload();
    }
  }, {
    key: "onEventsTabChanged",
    value: function onEventsTabChanged(tab) {
      var _this$state4 = this.state,
          upcoming = _this$state4.upcoming,
          past = _this$state4.past;
      this.setState({
        eventsTab: tab,
        isTabChanged: true
      });
      setQueryParameters({
        page: tab === 'upcoming' ? upcoming.currentPage : past.currentPage,
        tab: tab
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (typeof window === 'undefined') {
        return;
      }

      ;

      (function (history) {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var pushState = history.pushState;

        window.history.pushState = function (state) {
          if (typeof window.history.onpushstate === 'function') {
            window.history.onpushstate({
              state: state
            });
          } // @ts-expect-error


          return pushState.apply(history, arguments);
        };
      })(window.history);

      window.history.onpushstate = function () {
        // pushstate is async event, without setTimeout it is getting previous state
        window.setTimeout( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
          return _regenerator.default.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return _this2.onPushState();

                case 2:
                  return _context4.abrupt("return", _context4.sent);

                case 3:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        })), 0);
      }; // eslint-disable-next-line @typescript-eslint/unbound-method


      window.addEventListener('popstate', this.handleBackNavigation);
      var searchQuery = typeof window !== 'undefined' ? window.location.search : '';

      var queryParameters = _qs.default.parse(searchQuery, {
        ignoreQueryPrefix: true
      });

      var _this$state5 = this.state,
          upcoming = _this$state5.upcoming,
          past = _this$state5.past;

      if (!queryParameters.tab) {
        var _this$props = this.props,
            _this$props$upcomingE = _this$props.upcomingEventsNew,
            upcomingEventsNew = _this$props$upcomingE === void 0 ? [] : _this$props$upcomingE,
            _this$props$pastEvent = _this$props.pastEventsNew,
            pastEventsNew = _this$props$pastEvent === void 0 ? [] : _this$props$pastEvent;
        var hasUpcomingEvents = upcomingEventsNew && upcomingEventsNew.length > 0;
        var hasPastEvents = pastEventsNew && pastEventsNew.length > 0;

        if (hasUpcomingEvents) {
          setQueryParameters({
            tab: 'upcoming',
            page: upcoming.currentPage
          });
          this.setState({
            eventsTab: 'upcoming'
          });
        } else if (hasPastEvents) {
          setQueryParameters({
            tab: 'past',
            page: past.currentPage
          });
          this.setState({
            eventsTab: 'past'
          });
        }
      } else {
        this.setState({
          eventsTab: queryParameters.tab
        });

        if (queryParameters.page && queryParameters.tab === 'upcoming') {
          this.setState({
            upcoming: _objectSpread(_objectSpread({}, upcoming), {}, {
              currentPage: parseInt(queryParameters.page),
              showBackButton: parseInt(queryParameters.page) !== 1
            })
          });
        } else if (queryParameters.page && queryParameters.tab === 'past') {
          this.setState({
            past: _objectSpread(_objectSpread({}, past), {}, {
              currentPage: parseInt(queryParameters.page),
              showBackButton: parseInt(queryParameters.page) !== 1
            })
          });
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (typeof window === 'undefined') {
        return;
      } // eslint-disable-next-line @typescript-eslint/unbound-method


      window.removeEventListener('popstate', this.handleBackNavigation);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state6 = this.state,
          upcoming = _this$state6.upcoming,
          past = _this$state6.past,
          isLoading = _this$state6.isLoading,
          eventsTab = _this$state6.eventsTab;
      var timeConfig = this.props.timeConfig;
      var hasUpcomingEvents = upcoming.events && upcoming.events.length > 0;
      var hasPastEvents = past.events && past.events.length > 0;
      var isUpcomingEventsTab = eventsTab === 'upcoming';
      var showMoreButtonUpcoming = upcoming.currentPage < upcoming.totalPageCount;
      var showMoreButtonPast = past.currentPage < past.totalPageCount;
      var newPageUpcoming = upcoming.currentPage + 1;
      var newPagePast = past.currentPage + 1;
      return (0, _preact.h)("div", {
        className: "sections__nav events-overview"
      }, (0, _preact.h)("div", {
        className: "tabs--nav__container qa-events-nav-container"
      }, (0, _preact.h)("div", {
        className: "tabs--nav qa-events-tabs-nav"
      }, (0, _preact.h)("ul", {
        className: (0, _classnames.default)('tabs--navigation qa-tabs-menu qa-events-tabs')
      }, (0, _preact.h)("li", {
        key: "upcoming",
        className: (0, _classnames.default)('tabs__item', 'tabs__item--M', 'qa-tab'),
        onClick: function onClick() {
          return _this3.onEventsTabChanged('upcoming');
        }
      }, (0, _preact.h)("a", {
        onClick: function onClick(e) {
          return e.preventDefault();
        },
        role: "button",
        tabIndex: 0,
        className: "qa-link-tab js-tab ".concat(isUpcomingEventsTab ? ' is-active' : '')
      }, (0, _preact.h)(_phrase.default, {
        p: "events.title.upcoming",
        m: "Forum"
      }))), (0, _preact.h)("li", {
        key: "past",
        className: (0, _classnames.default)('tabs__item', 'tabs__item--M', 'qa-tab'),
        onClick: function onClick() {
          return _this3.onEventsTabChanged('past');
        }
      }, (0, _preact.h)("a", {
        onClick: function onClick(e) {
          return e.preventDefault();
        },
        role: "button",
        tabIndex: 0,
        className: "qa-link-tab js-tab ".concat(!isUpcomingEventsTab ? ' is-active' : '')
      }, (0, _preact.h)(_phrase.default, {
        p: "events.title.past",
        m: "Forum"
      })))))), (0, _preact.h)("div", null, isUpcomingEventsTab && upcoming.showBackButton || !isUpcomingEventsTab && past.showBackButton ? (0, _preact.h)("div", {
        className: (0, _classnames.default)('load-more-container back-to-top-button card-widget-wrapper')
      }, (0, _preact.h)("button", {
        className: "btn--cta btn--full-width btn--load-more ".concat(isLoading ? 'is-loading disabled' : ''),
        onClick: function onClick() {
          return _this3.setPagination(1);
        },
        type: "button"
      }, "Back to top of the list", (0, _preact.h)("span", {
        className: "loader"
      }))) : null, (0, _preact.h)("div", null, isUpcomingEventsTab && hasUpcomingEvents && (0, _preact.h)("div", {
        className: "event-list"
      }, (0, _preact.h)(_EventListOverview.default, {
        eventList: upcoming.events,
        timeConfig: timeConfig,
        className: "event-upcoming-wrapper"
      })), !isUpcomingEventsTab && hasPastEvents && (0, _preact.h)("div", {
        className: "event-list"
      }, (0, _preact.h)(_EventListOverview.default, {
        eventList: past.events,
        timeConfig: timeConfig,
        className: "event-upcoming-wrapper qa-event-past-wrapper"
      })), (isUpcomingEventsTab && !hasUpcomingEvents || !isUpcomingEventsTab && !hasPastEvents) && (0, _preact.h)("div", {
        className: "no-events"
      }, (0, _preact.h)(_phrase.default, {
        p: "events.no.events"
      }))), isUpcomingEventsTab && showMoreButtonUpcoming || !isUpcomingEventsTab && showMoreButtonPast ? (0, _preact.h)("div", {
        className: "load-more-container card-widget-wrapper"
      }, (0, _preact.h)("button", {
        className: "btn--cta btn--full-width btn--load-more ".concat(isLoading ? 'is-loading disabled' : ''),
        onClick: function onClick() {
          return _this3.setPagination(isUpcomingEventsTab ? newPageUpcoming : newPagePast);
        },
        type: "button"
      }, (0, _preact.h)(_phrase.default, {
        p: "events.show.more"
      }), (0, _preact.h)("span", {
        className: "loader"
      }))) : null));
    }
  }]);
  return EventOverviewNew;
}(_preact.Component);

var _default = EventOverviewNew;
exports.default = _default;